export const LANG = {
    SC: 'sc',
    TC: 'tc',
    EN: 'en',
    JA: 'ja'
};

export const LANG_OPTIONS = [
    { label: '简体', value: LANG.SC },
    { label: '繁体', value: LANG.TC },
    { label: '英文', value: LANG.EN },
    { label: '日语', value: LANG.JA }
];

export const AREA = {
    US: 'us'
};

export default {
    [AREA.US]: {
        [LANG.SC]: {
            empty: '空空如也，立即参与活动领取奖励',
            btn: '查看',
            detailBtn: '查看详情'
        },
        [LANG.TC]: {
            empty: '暫無獎勵，立即參與活動領取獎勵',
            btn: '審查',
            detailBtn: '查看詳情'
        },
        [LANG.EN]: {
            empty: 'No rewards yet, Complete task to receive rewards',
            btn: 'View',
            detailBtn: 'Details'
        },
        [LANG.JA]: {
            empty: '報酬はまだありません。報酬を受け取るにはタスクを完了してください',
            btn: '詳細',
            detailBtn: ''
        }
    }
};
